export const ADMIN = "ADMIN";
export const PROV = "PROV";
export const CONTROL = "CONTROL";